class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
           setTimeout(function () {
            // Free Shipping Code Start
             var amountInUSD = window.shippingSettings.freeShippingThresholdUSD; // e.g., 7000 cents = $70.00
              const activeCurrency = window.shippingSettings.currency;
          
              // Convert threshold using Shopify's currency script
              var convertedThreshold = Currency.convert(amountInUSD, 'USD', Shopify.currency.active);
          
              // Format for display (threshold)
              var formattedConvertedThreshold = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: Shopify.currency.active
              }).format(convertedThreshold / 100);
                 
              // Fetch cart and apply dynamic logic
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  var cartTotalUSD = cart.total_price;
                  cartTotalUSD = cartTotalUSD/100;
                  // Convert cart total to active currency (same as threshold)
                 
          
                  var remaining = convertedThreshold - cartTotalUSD;
                  let progress = 0;
                  if (remaining > 0) {
                    progress = Math.round((cartTotalUSD / convertedThreshold) * 100);
                  } else {
                    progress = 100;  // Fully filled if the cart total meets or exceeds threshold
                  }
              
                  // Update the progress bar width
                    const progressBar = document.getElementById("myBars");
                    if (progressBar) {
                      progressBar.style.width = progress + "%";
                    }
    
                    const progressBarcart = document.querySelector(".cart_page_bar");
                    if (progressBarcart) {
                      progressBarcart.style.width = progress + "%";
                    }
                     // console.log("Converted Threshold:", convertedThreshold);
                     // console.log("Converted Cart Total:", cartTotalUSD);
                    //  console.log("Remaining:", remaining);
              
                      // Format values for display
                      var formatter = new Intl.NumberFormat(undefined, {
                        style: 'currency',
                        currency: Shopify.currency.active,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      });
              
                      var message = document.querySelector(".cart-shipping-message");
              
                      if (message) {
                        if (cartTotalUSD === 0) {
                          message.textContent = "Add items to your cart to unlock free shipping!";
                        } else if (remaining > 0) {
                          message.innerHTML = `ONLY <strong>${formatter.format((remaining).toFixed(2))}</strong> away from free shipping!`;
                        } else {
                          message.textContent = "Congratulations! You've got free shipping!";
                        }
                      }
    
                      var Cartmessage = document.querySelector(".top-bar__message");
    
                        if (Cartmessage) {
                          if (cartTotalUSD === 0) {
                            Cartmessage.textContent = "Add items to your cart to unlock free shipping!";
                          } else if (remaining > 0) {
                            Cartmessage.innerHTML = `ONLY <strong>${formatter.format((remaining).toFixed(2))}</strong> away from free shipping!`;
                          } else {
                            Cartmessage.textContent = "Congratulations! You've got free shipping!";
                          }
                        }
                    });
            }, 500);
          // Free Shipping Code End
          
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        
        const parsedState = JSON.parse(state);
 
         setTimeout(function () {
            $(".ajax__upsell").load(location.href + " .ajax__upsell>*", "");
          }, 1000);
          // Free Shipping Code Start
        
             var amountInUSD = window.shippingSettings.freeShippingThresholdUSD; // e.g., 7000 cents = $70.00
              const activeCurrency = window.shippingSettings.currency;
          
              // Convert threshold using Shopify's currency script
              var convertedThreshold = Currency.convert(amountInUSD, 'USD', Shopify.currency.active);
          
              // Format for display (threshold)
              var formattedConvertedThreshold = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: Shopify.currency.active
              }).format(convertedThreshold / 100);

              // To check shipping currency price that is in main-cart-footer
        
              var shipamountInUSD = window.shippingpriceSettings.ShippingThresholdUSD;
              var shipconvertedThreshold = Currency.convert(shipamountInUSD, 'USD', Shopify.currency.active);
              var formattedConvertedThreshold = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: Shopify.currency.active
              }).format(shipconvertedThreshold / 100);
        
              // End To check shipping currency price that is in main-cart-footer
        
              // Fetch cart and apply dynamic logic
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  var cartTotalUSD = cart.total_price;
                  cartTotalUSD = cartTotalUSD/100;
                  // Convert cart total to active currency (same as threshold)
                 
          
                  var remaining = convertedThreshold - cartTotalUSD;
                  let progress = 0;
                    if (remaining > 0) {
                      progress = Math.round((cartTotalUSD / convertedThreshold) * 100);
                    } else {
                      progress = 100;  // Fully filled if the cart total meets or exceeds threshold
                    }
                
                    // Update the progress bar width
                      const progressBar = document.getElementById("myBars");
                      if (progressBar) {
                        progressBar.style.width = progress + "%";
                      }
                        
                      const progressBarcart = document.querySelector(".cart_page_bar");
                      if (progressBarcart) {
                        progressBarcart.style.width = progress + "%";
                      }
                        // console.log("Converted Threshold:", convertedThreshold);
                        // console.log("Converted Cart Total:", cartTotalUSD);
                        // console.log("Remaining:", remaining);
                
                        // Format values for display
                        var formatter = new Intl.NumberFormat(undefined, {
                          style: 'currency',
                          currency: Shopify.currency.active,
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        });


                       // To check shipping currency price that is in main-cart-footer
                       var cartshipText = document.querySelector(".ship_ammount");
                        if(cartshipText){
                         cartshipText.innerHTML = `<strong>${formatter.format((shipconvertedThreshold).toFixed(2))}</strong>`;
                        }
                       // End to check shipping currency price that is in main-cart-footer
                  
                        var message = document.querySelector(".cart-shipping-message");
                
                        if (message) {
                          if (cartTotalUSD === 0) {
                            message.textContent = "Add items to your cart to unlock free shipping!";
                          } else if (remaining > 0) {
                            message.innerHTML = `ONLY <strong>${formatter.format((remaining).toFixed(2))}</strong> away from free shipping!`;
                          } else {
                            message.textContent = "Congratulations! You've got free shipping!";
                          }
                        }
                      
                          var Cartmessage = document.querySelector(".top-bar__message");
      
                          if (Cartmessage) {
                            if (cartTotalUSD === 0) {
                              Cartmessage.textContent = "Add items to your cart to unlock free shipping!";
                            } else if (remaining > 0) {
                              Cartmessage.innerHTML = `ONLY <strong>${formatter.format((remaining).toFixed(2))}</strong> away from free shipping!`;
                            } else {
                              Cartmessage.textContent = "Congratulations! You've got free shipping!";
                              cartshipText.textContent = "Free"
                            }
                          }
                        
                      });
                       
             // Free Shipping Code End
        
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
